import { Routes } from '@angular/router';
import { authGuard } from './modules/protected/guards/auth.guard';
import { institutionGuard } from './modules/protected/guards/institution/institution.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'inst/:uniqueId',
    pathMatch: 'full',
    canActivate: [institutionGuard],
    loadComponent: () => import('./core/components/institution-profile/institution-profile.component').then(m => m.InstitutionProfileComponent)
  },
  {
    path: '',
    canActivate: [authGuard],
    loadChildren: () => import('./modules/protected/protected.module').then(m => m.ProtectedModule)
  },
  {
    path: '**',
    canActivate: [authGuard],
    redirectTo: ''
  }
];
